import { render } from "./DynamicFormPluginProp.vue?vue&type=template&id=6c7a34df&scoped=true&ts=true"
import script from "./DynamicFormPluginProp.vue?vue&type=script&lang=ts"
export * from "./DynamicFormPluginProp.vue?vue&type=script&lang=ts"

import "./DynamicFormPluginProp.vue?vue&type=style&index=0&id=6c7a34df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7a34df"]])

export default __exports__